// Importare i moduli
import './modules/setResponsiveClasses'
import './modules/ratiologos'
import './modules/accordion'
import './modules/navigation'
import './modules/smoothScroll'
import './modules/enableDisableForm'

// Rimozione classe no-js
document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/, 'js');